module.exports = __webpack_public_path__ + "static/media/Genie.2a0f34eb.jpg";